import axios from 'axios';

export const nodeApi = axios.create({baseURL: '/api/', withCredentials: true});
